var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"8","height":"5","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M1.172 0L.464.707 4 4.243 7.536.707 6.828 0 4 2.828 1.172 0z","fill":"#998F8A"}})])}
var staticRenderFns = []

export { render, staticRenderFns }